import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "forti-manager-item",
  templateUrl: "forti-manager-item.html",
  styleUrls: ["../../shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class FortiManagerItem {}
